import React, { useCallback, useEffect, useState } from 'react';

import { useGlobalContext } from '../../context/GlobalContext';
import { getAdminValidationDashboardAction } from '../../actions/questionsActions';
import AdminDashboard from './AdminDashboard';
import OwnerDashboard from './OwnerDashboard/OwnerDashboard';
import AdminValidationDashboard from './AdminValidationDashboard/AdminValidationDashboard';
import roleStyles from './RoleDashboard.module.scss';
import validationStyles from './AdminValidationDashboard/AdminValidationDashboard.module.scss';

export default function AdminDashboardSelector() {
  const [context, dispatch] = useGlobalContext();
  const { userAuth } = context.auth;
  const [validationDashboard, setValidationDashboard] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const divisions = userAuth?.division || [];
  const isMedicalAdmin = divisions.some((division) => ['DAP', 'Médical'].includes(division));

  const loadDashboard = useCallback(async () => {
    const dashboard = await getAdminValidationDashboardAction(dispatch);
    setValidationDashboard(dashboard);
    setIsLoading(false);
  }, [dispatch]);

  useEffect(() => {
    loadDashboard();
  }, [loadDashboard]);

  if (isLoading) {
    return <div className={`page-container ${roleStyles.container} ${validationStyles.page}`} />;
  }

  if (validationDashboard?.hasPendingValidation) {
    return <AdminValidationDashboard dashboard={validationDashboard} />;
  }

  if (isMedicalAdmin) {
    return <OwnerDashboard />;
  }

  return <AdminDashboard />;
}
